export default {
    set(state, { data }) {
      state.images = data;
    },
    show(state, { data }) {
      state.image = data;
    }
  }